import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResourceDetailsBaseComponent } from '../resource-details-base/resource-details-base.component';

@Component({
    selector: 'app-resource-details-material',
    templateUrl: './resource-details-material.component.html',
    styleUrls: ['./resource-details-material.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceDetailsMaterialComponent extends ResourceDetailsBaseComponent {
    constructor() {
        super();
    }
}
